module.exports = __webpack_public_path__ + "img/raiders-locker-room-bg.cfe75462.jpg";